"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationMismatchesSchema = exports.organizationMismatchSchema = exports.ORGANIZATION_MISMATCH_KINDS = exports.organizationMismatchesQuerySchema = void 0;
// Wire shape of the Organization tab's mismatch list (SPEC §8 Screen 9, §14.2 "the Organization tab shows
// where they disagree with the configured practices", §14.6; J-068), served as
// `GET /api/v1/organization-mismatches`. The configured side is the stored organization document, the
// document the tab edits; the other side is the year's loaded Participant List (F5) and Provider/Supplier
// List (F6). The billed-TIN row read the registry rows and left with them (J-184, J-185): the bundle's
// `ORG_MISMATCH` check compares the bundle's TINs. Every row names TINs and NPIs only.
//
// J-208: the lists compared are the selected year's (`?year=`, the shell's selector); without it, the
// organization document's `performance_year`. The Analysis bundle format (`VBLTC_BUNDLE_V1`) carries no
// CMS Participant or Provider/Supplier List, so the lists are still the loaded F5 and F6 batches.
const zod_1 = require("zod");
// No `.meta({ id })` on a querystring schema: @fastify/swagger expands parameters inline.
exports.organizationMismatchesQuerySchema = zod_1.z.object({
    year: zod_1.z.coerce.number().int().min(2000).max(2100).optional(),
});
exports.ORGANIZATION_MISMATCH_KINDS = [
    /** A configured practice's TIN is not on its ACO's Participant List. */
    "PRACTICE_NOT_ON_PARTICIPANT_LIST",
    /** A TIN on an ACO's Participant List is not a configured practice of that ACO. */
    "PARTICIPANT_NOT_A_PRACTICE",
    /** A configured group NPI under a TIN is not on its ACO's Provider/Supplier List. */
    "GROUP_NPI_NOT_ON_PROVIDER_LIST",
];
exports.organizationMismatchSchema = zod_1.z.object({
    kind: zod_1.z.enum(exports.ORGANIZATION_MISMATCH_KINDS),
    /** The ACO the row belongs to. */
    acoCode: zod_1.z.string(),
    tin: zod_1.z.string(),
    npi: zod_1.z.string().nullable(),
    /** The configured group, for a group NPI row. */
    groupName: zod_1.z.string().nullable(),
});
exports.organizationMismatchesSchema = zod_1.z
    .object({
    /** The year whose lists are compared: `?year=`, else the organization document's `performance_year`. */
    performanceYear: zod_1.z.number().int(),
    /** False when no Participant List is loaded for the year, so the list comparisons have nothing to use. */
    participantListLoaded: zod_1.z.boolean(),
    mismatches: zod_1.z.array(exports.organizationMismatchSchema),
})
    .meta({ id: "AcoOrganizationMismatches" });
//# sourceMappingURL=organization-mismatches.js.map